const $ = require("lc-jquery");
const sessionTimeout = require("dynamic-module-registry").get("siteConfig").sessionTimeout;

let idleSessionTimeoutPeriod = require("dynamic-module-registry").get("siteConfig").idleSessionTimeoutPeriod;
idleSessionTimeoutPeriod = parseInt(idleSessionTimeoutPeriod, 10);

let idleTime = 0,
  authUISessionTimer = 0;

$(document).ready(function () {
  // Increment the idle time counter every minute.
  setInterval(timerIncrement, 60000); // 1 minute

  // Zero the idle timer on mouse movement.
  $(this).mousemove(function (e) {
    idleTime = 0;
  });
  $(this).keypress(function (e) {
    idleTime = 0;
  });
  $(this).scroll(function (e) {
    idleTime = 0;
  });
});

function timerIncrement() {
  let path = window.location.pathname;

  idleTime = idleTime + 1;
  authUISessionTimer = authUISessionTimer + 1;

  if (idleTime >= idleSessionTimeoutPeriod && sessionTimeout === "true") {
    // 30 minutes
    window.location.href = "/login?reason=session-timeout";
  }

  if (
    authUISessionTimer >= idleSessionTimeoutPeriod &&
    (path.startsWith("/dashboard") || path.startsWith("/family-center") || path.startsWith("/admin-home"))
  ) {
    window.location.href = "/login";
  }
}

module.exports = {};

